<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useFianlyBranding } from './useFianlyBranding';
import welcomeImage from './assets/vista.jpeg';

const { t } = useI18n();
const currentUser = useMapGetter('getCurrentUser');
const { installationName, replaceInstallationName } = useFianlyBranding();
const greeting = computed(() => {
  const hour = new Date().getHours();
  const values = {
    name: currentUser.value.name,
    installationName: installationName.value,
  };
  if (hour < 12) {
    return replaceInstallationName(t('ONBOARDING.GREETING_MORNING', values));
  }
  if (hour < 18) {
    return replaceInstallationName(t('ONBOARDING.GREETING_AFTERNOON', values));
  }
  return replaceInstallationName(t('ONBOARDING.GREETING_EVENING', values));
});
</script>

<template>
  <section
    class="h-full min-h-0 w-full overflow-hidden bg-n-background px-3 py-3 sm:px-6 sm:py-4"
    aria-labelledby="fianly-welcome-heading"
  >
    <div class="mx-auto flex h-full min-h-0 w-full max-w-5xl flex-col">
      <h1
        id="fianly-welcome-heading"
        class="mb-3 shrink-0 text-base font-semibold leading-6 text-n-slate-12 sm:text-xl"
      >
        {{ greeting }}
      </h1>
      <div
        class="mx-auto flex min-h-0 w-full flex-1 items-center justify-center overflow-hidden"
      >
        <img
          :src="welcomeImage"
          :alt="installationName"
          width="1024"
          height="1152"
          class="block h-full min-h-0 w-full object-contain"
          decoding="async"
        />
      </div>
    </div>
  </section>
</template>
